//import React from 'react';

// Import icons
import { 
  Cpu,
  CalendarCheck,
  CalendarClock,
  AudioLines,
  SunSnow,
  Clock,
  Zap,
  Target,
  CannabisIcon,
  BarChart3,
  Package,
  Hash,
  Box,
  Ruler,
  Radio,
  Shield,
  Thermometer,
  Gauge,
  AlertTriangle,
  FileText,
  X
} from 'lucide-react';

// Icon mapping based on string names from your data
export const iconMap = {
  'Cpu': Cpu,
  'Clock': Clock,
  'CalendarCheck': CalendarCheck,
  'CalendarClock': CalendarClock,
  "CannabisIcon": CannabisIcon,
  'Zap': Zap,
  'BarChart3': BarChart3,
  'Radio': Radio,
  'Thermometer': Thermometer,
  'Gauge': Gauge,
  'Shield': Shield,
  "SunSnow": SunSnow,
  "AudioLines": AudioLines,
  // Add fallback for any missing icons
  'default': Clock
};

// Helper function to safely get icon with fallback
export const getIcon = (iconName) => {
  return iconMap[iconName] || iconMap.default;
};